'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _templateObject = _taggedTemplateLiteral(['\n  ', ';\n  float: left;\n  width: ', ';\n  max-width: ', ';\n  min-width: ', ';\n  margin-left: ', ';\n  margin-bottom: ', 'px;\n  padding: 0px 15px;\n  ', ';\n  ', ';\n  ', ';\n'], ['\n  ', ';\n  float: left;\n  width: ', ';\n  max-width: ', ';\n  min-width: ', ';\n  margin-left: ', ';\n  margin-bottom: ', 'px;\n  padding: 0px 15px;\n  ', ';\n  ', ';\n  ', ';\n']),
    _templateObject2 = _taggedTemplateLiteral(['\n    ', '\n    ', '\n  '], ['\n    ', '\n    ', '\n  ']),
    _templateObject3 = _taggedTemplateLiteral(['\n    padding: 0px 5px;\n    ', '\n    ', '\n  '], ['\n    padding: 0px 5px;\n    ', '\n    ', '\n  ']);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _polished = require('polished');

var _media = require('../../../libs/media');

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _taggedTemplateLiteral(strings, raw) {
  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
} // Styles
// Libs


var Column = _styledComponents2.default.div(_templateObject, (0, _polished.clearFix)(), function (_ref) {
  var size = _ref.size;
  return size * 100 + '%';
}, function (_ref2) {
  var size = _ref2.size;
  return size * 100 + '%';
}, function (_ref3) {
  var size = _ref3.size;
  return size * 100 + '%';
}, function (_ref4) {
  var offset = _ref4.offset;
  return !!offset ? offset * 100 + '%' : '0px';
}, function (_ref5) {
  var margin = _ref5.margin;
  return margin ? 30 : 0;
}, _media.media.l(_templateObject2, function (_ref6) {
  var l = _ref6.l;
  return l > 0 ? 'width: ' + l * 100 + '%; min-width: ' + l * 100 + '%; max-width: ' + l * 100 + '%;' : '';
}, function (_ref7) {
  var offset_l = _ref7.offset_l;
  return !!offset_l || offset_l === 0 ? 'margin-left: ' + offset_l * 100 + '%;' : '';
}), _media.media.m(_templateObject2, function (_ref8) {
  var m = _ref8.m;
  return m > 0 ? 'width: ' + m * 100 + '%; min-width: ' + m * 100 + '%; max-width: ' + m * 100 + '%;' : '';
}, function (_ref9) {
  var offset_m = _ref9.offset_m;
  return !!offset_m || offset_m === 0 ? 'margin-left: ' + offset_m * 100 + '%;' : '';
}), _media.media.s(_templateObject3, function (_ref10) {
  var s = _ref10.s;
  return s > 0 ? 'width: ' + s * 100 + '%; min-width: ' + s * 100 + '%; max-width: ' + s * 100 + '%;' : '';
}, function (_ref11) {
  var offset_s = _ref11.offset_s;
  return !!offset_s || offset_s === 0 ? 'margin-left: ' + offset_s * 100 + '%;' : '';
}));

Column.propTypes = {
  size: _propTypes2.default.number.isRequired,
  offset: _propTypes2.default.number,
  l: _propTypes2.default.number,
  m: _propTypes2.default.number,
  s: _propTypes2.default.number,
  offset_l: _propTypes2.default.number,
  offset_m: _propTypes2.default.number,
  offset_s: _propTypes2.default.number,
  margin: _propTypes2.default.bool
};
Column.defaultProps = {
  size: 1,
  offset: 0,
  l: 0,
  m: 0,
  s: 0,
  margin: false
};
exports.default = Column;